/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PageHeader from "../../../components/PageHeader";
import useForm from "../../../hooks/useForm";
import { getConfigurationList } from "../../../apis/tax-portal/tax-singo/tax-singo";
import { getTaxSingoRepetitionType, getTaxSingoStatus } from "../../../utils/taxPortal/tax-singo";
import { ControlTable } from "../../../components/Table";
import Filters from "../../../components/Filters";
import DataComponent from "../../../components/DataComponent";
import { TAX_SINGO_STATUS_LIST } from "../../../constants/TaxPortal/TAX_SINGO";
import { getParams } from "../../../utils/params";
import TaxSingoConfirutation from "../../../components/TaxPortal/TaxSingo/TaxSingoConfiguration";
import { DAY_OF_THE_WEEKS } from "../../../constants/DAY";
import { dateToFormat } from "../../../utils/date";

const TaxSingoConfigurationList = (props) => {

  const [fields] = useState(
    [
      {
        title: "상태",
        key: "status",
        onValue: (_data, _field, datas) => {
          const { color, label } = getTaxSingoStatus(datas.status)
          return <DataComponent field={
            {
              type: 'badge',
              color,
              label
            }
          }
          />;
        },
        width: 88,
      },
      {
        title: "유형",
        key: "singoType",
        width: 145,
      },
      {
        title: "신고명",
        align: "left",
        key: "name",
        type: 'ellipsis',
        onValue: (data, _field, datas) => {
          return <>
            {datas.name}{datas.description ? <>
              <small>{datas.description}</small>
            </> : ''}
          </>
        }
      },
      {
        title: "시작일",
        onValue: (data, _field, datas) => {
          const repetitionType = getTaxSingoRepetitionType(datas?.repetitionType)
          let repetitionText = ``

          if (repetitionType.value !== 'null') {
            repetitionText += `${repetitionType.label} `
            if (repetitionType.value === 'weekly') {
              const weekList = (datas?.repetitionDay || '').split(',')
              for (const [idx, weekDay] of weekList.entries()) {
                if (idx > 0) repetitionText += ', '
                repetitionText += DAY_OF_THE_WEEKS.find((d) => d.value === Number(weekDay))?.label
              }
            } else {
              if (datas.repetitionMonth) repetitionText += `${datas.repetitionMonth}월 `
              if (datas.repetitionDay) repetitionText += `${datas.repetitionDay}일 `
            }
          } else {
            repetitionText = dateToFormat(datas.createdTiem)
          }

          return <>{repetitionText}</>
        }
      },
      {
        title: "생성일",
        key: 'schedulerAdvanceDays',
        tooltip: {
          tooltiptext: "시작일 기준 생성일\n양수 : 시작일 이후\n음수 : 시작일 이전"
        }
      },
      {
        title: "종료일",
        key: 'reportDueOffsetDays',
        tooltip: {
          tooltiptext: "시작일 기준 종료일"
        }
      },
      {
        title: "항목 수",
        width: 180,
        onValue: (data, _field, datas) => {
          return <>{`${datas?.data?.length || 0}개`}</>
        }
      },
      {
        title: "생성일",
        type: 'date',
        key: "createdTime",
        width: 130,
      },

    ]);

  const {
    form,
    setSubmit,
    handleOnChange,
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    reSubmit,
  } = useForm({
    limit: 10,
    offset: 0,
    search: {}
  });

  useEffect(() => {
    setSubmit(submit);
    submit(form);
  }, []);

  const submit = (form) => {
    if (form.search.status === 'all') delete form.search.status
    setIsLoading(true);
    getConfigurationList(getParams(form))
      .then((res) => {
        setList(res.data.data);
        setTotal(res.data.total)
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };


  const [filters] = useState([
    {
      title: '신고명',
      key: 'search.name'
    },
    {
      title: "상태",
      key: "search.status",
      type: "select",
      value: "all",
      options: {
        list: [
          { label: "전체", value: "all" },
          ...TAX_SINGO_STATUS_LIST
        ]
      }
    },
  ]);





  const [formData, setFormData] = useState({});
  const [mode, setMode] = useState("create");
  const [detailOpen, setDetailOpen] = useState(false);
  const headerButtons = [
    {
      label: "신고설정 생성",
      action: () => {
        setFormData(null)
        setMode('create')
        setDetailOpen(true);
      },
    },
  ];

  const onSelect = (data) => {
    setFormData(data)
    setMode('view')
    setDetailOpen(true)
  }
  return (
    <div>
      <div className="tax-singo-wrap">
        <PageHeader
          title={`신고설정`}
          buttons={headerButtons}
        />

        <div className="tax-singo-description-wrap" style={{ height: '145px' }}>
          <div className="tax-singo-description-text-wrap">
            <span className="tax-singo-description-text">
              생성된 신고설정은 데이터 보존을 위해 일부만 수정 가능합니다.<br />
              변경이 필요할 경우 사용상태를 중지하고 복사를 이용해 주세요.<br />
              <br />
              실행되는 시점의 주담당자 및 담당자 지정된 인원에게 신고 할당됩니다.<br />
              담당자가 없는 경우 수임처의 신고스케줄이 생성되지 않을 수 있으니 꼭 확인해주세요.
            </span>
          </div>
        </div>

        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange}
        />
        <ControlTable
          isLoading={isLoading}
          fields={fields}
          list={list}
          total={total}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          onSelect={onSelect}
        />
      </div>

      <TaxSingoConfirutation
        open={detailOpen}
        setOpen={setDetailOpen}
        mode={mode}
        setMode={setMode}
        formData={formData}
        setFormData={setFormData}
        submit={reSubmit}
      />
    </div>
  );
};

export default TaxSingoConfigurationList;
